"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentArea = void 0;
var ComponentArea;
(function (ComponentArea) {
    ComponentArea["Editor"] = "editor-editor";
    ComponentArea["Themes"] = "themes";
    ComponentArea["EditorStack"] = "editor-stack";
})(ComponentArea || (exports.ComponentArea = ComponentArea = {}));
